import { render } from "./OptimizaTable.vue?vue&type=template&id=047ac52e&scoped=true"
import script from "./OptimizaTable.vue?vue&type=script&lang=js"
export * from "./OptimizaTable.vue?vue&type=script&lang=js"

import "./OptimizaTable.vue?vue&type=style&index=0&id=047ac52e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047ac52e"]])

export default __exports__